import { Intervalo } from "./Intervalo";

export class CharInfo {
  public index: number;
  public preencher: Intervalo;
  public sublinhar: Intervalo;
}
